module.exports = __webpack_public_path__ + "img/hold.94b28724.svg";